import { FIELD_LABELS_DA } from "@/api/cle-api/errors";
import type { AuditTrailFieldChange } from "@/api/cle-api/models/documents";

import { formatCourseDuration } from "./courseDuration";
import { formatAmount, formatBoolean, formatDateLong } from "./formatters";

const ISO_DATE_PATTERN = /^\d{4}-\d{2}-\d{2}/;

/** `course_time` is a duration in minutes, so "180" alone reads as wrong. */
const DURATION_FIELDS = new Set(["course_time", "courseTime"]);

export const formatAuditTrailFieldLabel = (field: string): string =>
  FIELD_LABELS_DA[field] ??
  field
    .replace(/_/g, " ")
    .replace(/([a-z])([A-Z])/g, "$1 $2")
    .replace(/^\w/, (char) => char.toUpperCase());

export const formatAuditTrailFieldValue = (
  field: string,
  value: unknown,
): string => {
  if (value == null || value === "") {
    return "—";
  }

  if (typeof value === "boolean") {
    return formatBoolean(value);
  }

  if (typeof value === "number") {
    if (DURATION_FIELDS.has(field)) {
      return formatCourseDuration(value);
    }

    if (field.includes("amount")) {
      return formatAmount(value);
    }

    return value.toLocaleString("da-DK");
  }

  if (typeof value === "string" && ISO_DATE_PATTERN.test(value)) {
    return formatDateLong(value);
  }

  return String(value);
};

export const getAuditTrailFieldChanges = (
  fieldChanges?: AuditTrailFieldChange[],
): AuditTrailFieldChange[] => fieldChanges ?? [];
